import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-inaccurate-navigation-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="route-dialog-backdrop" (click)="cancel()">
      <div class="route-dialog" (click)="$event.stopPropagation()">
        <div class="route-dialog-header">
          <h4>Nepřesná navigace</h4>
        </div>
        <div class="route-dialog-body">
          Zvolená místnost se nachází v nenaskenované budově, přesná navigace není možná,
          budete navigování do budovy zvolené místnosti.
        </div>
        <div class="route-dialog-footer">
          <button class="link-btn" (click)="ok()">Ok</button>
          <button class="link-btn" (click)="cancel()">Zpět</button>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class InaccurateNavigationDialogComponent {
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  ok(): void {
    this.confirmed.emit();
  }

  cancel(): void {
    this.cancelled.emit();
  }
}
